import {
  ButtonType,
  ActionButton,
} from '../../../../shared/components/refactor-components/layouts/icp-onboarding/icp-onboarding.model';
import { Component } from '@angular/core';
import { IcpCarouselModel } from '../../../../shared/components/refactor-components/ui/icp-carousel/carousel-images.model';
import { slideInOutAnimation } from '../../animations/router.animations';
import { BaseFormComponent } from '../../../../shared/components/refactor-components/base-form/base-form.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RecoveryService } from '../../services/recovery.service';
import { UserMessages } from '../../constants/messages.constants';
import { CustomValidators } from 'ng2-validation';
import * as Sentry from '@sentry/browser';
import { IcpAlertService } from '../../../../shared/components/refactor-components/ui/icp-alert/icp-alert.service';
import { DirectionsEnum } from '../../../../shared/components/refactor-components/layouts/icp-splitted-screen/icp-splitted-screen.model';

@Component({
  selector: 'app-esqueci-minha-senha',
  templateUrl: './esqueci-minha-senha.component.html',
  styleUrls: ['./esqueci-minha-senha.component.scss'],
  animations: [slideInOutAnimation],
  host: { '[@slideInOutAnimation]': '' },
})
export class EsqueciMinhaSenhaComponent extends BaseFormComponent {
  contrastSide: string = DirectionsEnum.LEFT;

  images: Array<IcpCarouselModel> = [
    {
      url: '/assets/img/login-carousel-01.svg',
      alt: 'Imagem carrossel login 1',
      caption: 'Potencialize o poder de <br> pagamento <b>dos seus pacientes.</b>',
    },
    {
      url: '/assets/img/login-carousel-02.svg',
      alt: 'Imagem carrossel login 2',
      caption: '<b>Antecipe já!</b> Recursos para <br> sua clínica sem gerar dívidas.',
    },
    {
      url: '/assets/img/login-carousel-03.svg',
      alt: 'Imagem carrossel login 3',
      caption:
        'Quer ter mais tempo para curtir a <br> vida? <b>Otimize seus atendimentos.</b>',
    },
  ];

  success: string = null;
  error: string = null;
  showLoading: boolean = false;

  btnEnviar: ActionButton = {
    buttonType: ButtonType.Loading,
    text: 'Enviar',
    buttonClass: 'button-primary',
    showLoading: false,
  };

  btnVoltar: ActionButton = {
    buttonType: ButtonType.Default,
    text: 'Voltar para o login',
    buttonClass: 'button-primary-outline inverse',
    routerLink: '/login',
    icon: 'arrow_back',
  };

  actions: ActionButton[] = [this.btnEnviar, this.btnVoltar];

  constructor(
    private fb: FormBuilder,
    private recoveryService: RecoveryService,
    private icpAlertService: IcpAlertService
  ) {
    super(
      { email: '' },
      {
        email: {
          required: UserMessages.EMAIL_REQUIRED,
          email: UserMessages.EMAIL_INVALID,
        },
      },
      fb
    );
  }

  ngOnInit() {
    this.buildForm();
  }

  initializeForm(): FormGroup {
    return this.fb.group({
      email: ['', Validators.compose([Validators.required, CustomValidators.email])],
    });
  }

  sendForm(): any {
    this.showLoading = true;
    return this.recoveryService.requestRecovery(this.form.value.email).subscribe(
      (res) => {
        this.handleSuccess(res);
      },
      (res) => {
        Sentry.captureException(new Error(res));
        this.handleResponseErrors(res);
      }
    );
  }

  handleSuccess(res: any) {
    this.showLoading = false;
    this.btnEnviar.showLoading = false;
    const message = res.messages[0];
    if (res.error) {
      this.icpAlertService.warn(message);
    } else {
      this.icpAlertService.success(message);
    }
  }

  handleResponseErrors(errors) {
    if (errors && errors['error']) {
      this.showLoading = false;
      this.btnEnviar.showLoading = false;
      this.error = errors['error'].messages[0];
      this.icpAlertService.error('Ocorreu um erro!');
    }
  }

  handleErrors() {}

  submitForm() {
    if (this.form.controls.email.value) {
      this.onSubmit(this.form.value);
    }
  }
}
